import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";

export default function AddCustomer() {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location>>>>>>>>>>.", location);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (location?.state) {
      reset({
        name: location?.state?.data?.name,
        email: location?.state?.data?.email,
        phone: location?.state?.data?.phone,
        address: location?.state?.data?.address,
        gstNumber: location?.state?.data?.gstNumber
      })
    }
  }, [])

  const onSubmit = (data) => {
    const submitData = {
      name: data?.name,
      email: data?.email,
      phone: data?.phone,
      address: data?.address,
      gstNumber: data?.gstNumber,
    };
    // console.log("submitData >>>>>>>>>>>>", submitData);
    const options = {
      method: "POST",
      data: submitData,
    };
    if (location?.state) {
      let API = apiUrl?.Update_Customer + `?customerId=${location?.state?.data?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          navigate(-1);
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      let API = apiUrl?.add_customer;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          navigate(-1);
        } else {
          toast.error(response?.message);
        }
      });
    }
  };

  return (

    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">{location?.state ? "Update" : "Add "} Customer</h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-BasicDetails"
                  role="tabpanel"
                  aria-labelledby="pills-BasicDetails-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    <div className="col-12">
                      <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                        Normal Details
                      </h4>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="shiftName" className="form-label">
                          Firm Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Firm Name"
                          id="shiftName"
                          aria-describedby="emailHelp"
                          {...register("name", {
                            required: "This field is Required",
                          })}
                        />
                        <ErrorMessage message={errors?.name?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="EndTime" className="form-label">
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="EndTime"
                          placeholder="Enter Email"
                          {...register("email", {
                            required: "This field is Required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                              message: "Invalid email address",
                            },
                            validate: (value) =>
                              value === value.toLowerCase() ||
                              "Email must be in lowercase",
                          })}
                        />
                        <ErrorMessage message={errors?.email?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="check-Out" className="form-label">
                          Contact Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          className="form-control"
                          placeholder="Enter Contact No."
                          id="check-Out"
                          {...register("phone", {
                            required: "This field is Required",
                          })}
                        />
                        <ErrorMessage message={errors?.phone?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="Address" className="form-label">
                          Address
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="Address"
                          rows={3}
                          defaultValue={""}
                          {...register("address", {
                            required: "This field is Required",
                          })}
                        />
                        <ErrorMessage message={errors?.address?.message} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="form-group mb-3">
                        <label htmlFor="Early-count" className="form-label">
                          GST Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter GST Number"
                          id="gst-number"
                          {...register("gstNumber", {
                            required: "This field is required",
                            pattern: {
                              value: /^[0-9A-Z]+$/,
                              message:
                                "GST Number must be in uppercase letters and numbers only",
                            },
                          })}
                        />
                        <ErrorMessage message={errors?.gstNumber?.message} />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-end gap-4">
                    <button
                      className="btn btn-secondary px-5"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </button>
                    <button
                      disabled={isLoading}
                      type="submit"
                      className="btn btn-primary px-5"
                    >
                      {isLoading ? <Spinner /> : location?.state ? "Update" : "Create"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
